import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./Reports.css";

function Reports() {
  return (
    <div className="reports-ops">
      <PowerBIEmbed
        embedConfig={{
          type: "report", // Supported types: report, dashboard, tile, visual and qna
          id: "24f702be-becd-4a5c-94c9-a60dc3b3b337",
          embedUrl:
            "https://app.powerbi.com/reportEmbed?reportId=24f702be-becd-4a5c-94c9-a60dc3b3b337&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",
          accessToken:
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvZTAwYjY2ODctYzc3Ni00NTE0LThhMTItNTU0OWMwYWFiYjc5LyIsImlhdCI6MTY4MzU2MDQ4NywibmJmIjoxNjgzNTYwNDg3LCJleHAiOjE2ODM1NjQ2MDcsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBVlFBcS84VEFBQUFQV2lEMHNJajcrMGpNeWZxbVVUbzEyL09xaUl6alJEa0ZEZy9LS2hRZDNqU0sxSDRVMStSVG9nd2JmNFhlcjlpV0lXajdzZ1R2d1IxMWFQZk5FQUIzUGpCQy9XTHFleVpFTm4zVDBERTdKQT0iLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcGlkIjoiMThmYmNhMTYtMjIyNC00NWY2LTg1YjAtZjdiZjJiMzliM2YzIiwiYXBwaWRhY3IiOiIwIiwiZmFtaWx5X25hbWUiOiJTdXJlIiwiZ2l2ZW5fbmFtZSI6IlNyaWthbnRoIiwiaXBhZGRyIjoiMTAzLjE2OC44MC45IiwibmFtZSI6IlNyaWthbnRoIFN1cmUiLCJvaWQiOiJiY2EyMzZjMS1jMzgxLTQ4N2YtYjNlMC02Yzg5ZGRhOGNjMjkiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtMjA1MDQ5NjM5LTI1ODcxODU2NTUtMzA0OTIzODM0Ni01Njk2MiIsInB1aWQiOiIxMDAzMjAwMjQ3REYyOUFBIiwicmgiOiIwLkFRY0FoMllMNEhiSEZFV0tFbFZKd0txN2VRa0FBQUFBQUFBQXdBQUFBQUFBQUFBSEFBay4iLCJzY3AiOiJBcHAuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZC5BbGwgQ2FwYWNpdHkuUmVhZFdyaXRlLkFsbCBDb250ZW50LkNyZWF0ZSBEYXNoYm9hcmQuUmVhZC5BbGwgRGFzaGJvYXJkLlJlYWRXcml0ZS5BbGwgRGF0YWZsb3cuUmVhZC5BbGwgRGF0YWZsb3cuUmVhZFdyaXRlLkFsbCBEYXRhc2V0LlJlYWQuQWxsIERhdGFzZXQuUmVhZFdyaXRlLkFsbCBHYXRld2F5LlJlYWQuQWxsIEdhdGV3YXkuUmVhZFdyaXRlLkFsbCBQaXBlbGluZS5EZXBsb3kgUGlwZWxpbmUuUmVhZC5BbGwgUGlwZWxpbmUuUmVhZFdyaXRlLkFsbCBSZXBvcnQuUmVhZC5BbGwgUmVwb3J0LlJlYWRXcml0ZS5BbGwgU3RvcmFnZUFjY291bnQuUmVhZC5BbGwgU3RvcmFnZUFjY291bnQuUmVhZFdyaXRlLkFsbCBUZW5hbnQuUmVhZC5BbGwgVGVuYW50LlJlYWRXcml0ZS5BbGwgVXNlclN0YXRlLlJlYWRXcml0ZS5BbGwgV29ya3NwYWNlLlJlYWQuQWxsIFdvcmtzcGFjZS5SZWFkV3JpdGUuQWxsIiwic2lnbmluX3N0YXRlIjpbImttc2kiXSwic3ViIjoiMG1BR2pNRGRKQXB6ZDRYNlNYdTRJZ1BXNXFYcFE2WWhLSnBGeWtiTlZEUSIsInRpZCI6ImUwMGI2Njg3LWM3NzYtNDUxNC04YTEyLTU1NDljMGFhYmI3OSIsInVuaXF1ZV9uYW1lIjoiU3Jpa2FudGguU3VyZUBnZW56ZW9uLmNvbSIsInVwbiI6IlNyaWthbnRoLlN1cmVAZ2VuemVvbi5jb20iLCJ1dGkiOiJSZm9BVEQ5VktFaTRJM1Mwc0U0dkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXX0.CbxntENYbIrSoMble2s7osfv9-mN_GNxzeQURleKihJGzu4uYRFtYckBvyLqgTVG7B-bryZ6epRfs9wQMXtlW2GEIuv5F29lWo2L8ZhkX_wF-iht1V82_o5SRmJPVCicM0K0uQpUmaeTWAE7QZTa8uYL_tbAO6gYcNs3D-_4pjH3MTpMnCA-WAAx8_kFc649xyZ9P9gcbtt-_kro1Kmb43SNawdhJUXjPbTuauikU3Mud3Wan5FdPsXlpo_HtxBUcVKpX_ZECuvDMbv7z1kZCN3ayHyk75ohSuwZAT112J9GD8NT5b-9P8PtwT5I13QrZbnXDAbYG_oFemCWLZnwNQ",
          tokenType: models.TokenType.Aad,
          settings: {
            panes: {
              filters: {
                expanded: false,
                visible: false,
              },
            },
            background: models.BackgroundType.Transparent,
          },
        }}
        eventHandlers={
          new Map([
            [
              "loaded",
              function () {
                console.log("Report loaded");
              },
            ],
            [
              "rendered",
              function () {
                console.log("Report rendered");
              },
            ],
            [
              "error",
              function (event) {
                console.log(event.detail);
              },
            ],
          ])
        }
        cssClassName={"dashboard-report-container"}
        getEmbeddedComponent={(embeddedReport) => {
          window.report = embeddedReport;
        }}
      />
    </div>
  );
}

export default Reports;
